<ng-template #authenticationRef>
  <div id="otp-modal">
    <div class="otpmain auth-section otp-component">
      <div class="otpsub otp-modal-background">
        <div class="head">
          <div style="text-align: center">
            <img
              itemprop="image"
              class="logo logo-dark mt-x1"
              alt="CoinZoom Exchange"
              src="./assets/image/icons/logo_white.svg"
              width="200"
            />
          </div>
          <span *ngIf="showBiometricOptions"
            ><fa-icon class="shield" [icon]="faShieldAlt"></fa-icon>Confirm using the CoinZoom Mobile app</span
          >
          <span *ngIf="app2FAAvailable">Authenticator App OTP</span>
          <span *ngIf="email2FAAvailable">Enter Email OTP</span>
          <span>
            <button type="button" class="close pull-right" aria-label="Close" (click)="otpVerificationForm?.reset(); hideModal()">X</button>
          </span>
        </div>
        <div class="by" [hidden]="!showBiometricOptions || fallbackToGoogleAuth">
          <div class="bio-2fa-details">
            We've sent an authentication request to your CoinZoom mobile app
            <fa-icon [icon]="faMobileAlt"></fa-icon>
          </div>
          <div class="bio-2fa-explanation">
            To protect your funds we want to make sure this is really you. Please confirm by entering the code below on your mobile app.
            Don't see the request?
            <p class="signtogl linkText-container">
              <a class="en_pointer linkText" (click)="resendAppPush()">Resend</a>
            </p>
          </div>

          <div class="bio-2fa-code">
            <div class="bio-2fa-code-inner">
              {{ confirmationCode }}
            </div>
          </div>
        </div>
        <div class="bio-2fa-alternative" *ngIf="showBiometricOptions && !fallbackToGoogleAuth">
          <div>Having difficulty? Please ensure you're using the latest version of the mobile app.</div>
          <div>
            Alternatively click
            <p class="signtogl linkText-container">
              <a class="en_pointer linkText" (click)="fallbackToGoogleAuth = true">here</a>
            </p>
            to confirm using a 6 digit code.
            <fa-icon
              [icon]="faQuestionCircle"
              [ngbTooltip]="mfaHelp"
              tooltipClass="two-fa-tooltip"
              triggers="click:blur"
              container="body"
            ></fa-icon>
          </div>
        </div>
        <div class="bio-2fa-alternative" style="margin-top: 20px" *ngIf="fallbackToGoogleAuth">
          <p>
            If you have your 6 digit two factor authentication (2FA) code stored in an authenticator app enter it below. This is also
            referred to as an OTP code.
          </p>
          <p>
            You can also access the 6 digit code from the More tab in the CoinZoom mobile app (using the
            <span class="app-menu-highlight">Get Two Factor Auth Code</span> menu in the <span class="app-menu-highlight">More</span> tab).
            If you can't see this option please ensure you're using the latest version of the app.
          </p>
          <div>
            Click
            <p class="signtogl linkText-container">
              <a class="en_pointer linkText" (click)="fallbackToGoogleAuth = false">here</a>
            </p>
            to return to the phone biometric options.
          </div>
        </div>
        <div [class.by]="!biometric2FAAvailable" [hidden]="showBiometricOptions && !fallbackToGoogleAuth">
          <div class="two-fa-info">
            <form
              (ngSubmit)="submitOtp()"
              #otpVerificationForm="ngForm"
              method="post"
              name="otpVerificationForm"
              class="mt-20 pos-rel"
              autocomplete="off"
            >
              <label *ngIf="label">{{ label }}</label>
              <div class="form-group">
                <input
                  id="otpCode"
                  (keydown)="onlyNumericAllowed($event)"
                  [placeholder]="email2FAAvailable ? 'Email OTP code' : 'Authenticator Code'"
                  class="form-control noscroll"
                  [class.email-otp]="email2FAAvailable"
                  name="otpCode"
                  [(ngModel)]="otpCodeValue"
                  #otpCode="ngModel"
                  required
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  type="number"
                  maxlength="6"
                />
                <span class="resend-otp" (click)="sendOtpEmail(true)" *ngIf="email2FAAvailable">Resend OTP</span>
                <div *ngIf="otpCode.invalid && otpCode.touched" class="alert alert-danger">
                  <ng-container *ngIf="otpCode.errors?.required">
                    <div *ngIf="email2FAAvailable; else appOtp">Please enter email OTP</div>
                    <ng-template #appOtp>
                      <div>Please enter authenticator app OTP</div>
                    </ng-template>
                  </ng-container>
                </div>
              </div>

              <div class="btn-div">
                <button
                  id="submit-otp"
                  class="btn btn-success btn-block submit border-green"
                  [disabled]="!otpVerificationForm.valid || otpBeingProcessed"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #mfaHelp>
  <div class="two-fa-tooltip-help-text">
    <p>If you have your 6 digit two factor authentication (2FA) code stored in an authenticator app you can enter it.</p>
    <p>
      You can also access the 2FA code from the More tab in the CoinZoom mobile app (using the
      <span class="app-menu-highlight">Get Two Factor Auth Code</span> menu in the <span class="app-menu-highlight">More</span> tab).
    </p>
  </div>
</ng-template>
